import { lazyLoad } from '../../../../shared/utils/loadable';

export const PasswordResetNewPage = lazyLoad(
  () => import('./index'),
  (module) => module.PasswordResetNew,
);
